
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/sobre-nosotros",
      function () {
        return require("private-next-pages/3catinfo/sobre-nosotros/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/sobre-nosotros"])
      });
    }
  